// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

// eslint-disable-next-line spaced-comment
/// <reference types="@types/google.analytics" />

export function defaultGetOptions(): RequestInit {
    const headers: HeadersInit = new Headers();
    headers.set('Content-Type', 'application/json');

    const options: RequestInit = {
        method: 'GET',
        headers: headers,
    };

    if (window.ga) {
        window.ga((tracker: UniversalAnalytics.Tracker | undefined) => {
            headers.set('Protolabs-Analytics-Id', tracker?.get('clientId'));
        });
    }

    return options;
}

export function defaultHeadOptions(): RequestInit {
    return { ...defaultGetOptions(), ...{ method: 'HEAD' } };
}

export function defaultDeleteOptions(): RequestInit {
    return { ...defaultGetOptions(), ...{ method: 'DELETE' } };
}

export function defaultPatchOptions(payload = {}): RequestInit {
    const additionalOptions = {
        method: 'PATCH',
        body: JSON.stringify(payload),
    };

    return { ...defaultGetOptions(), ...additionalOptions };
}

export function defaultPutOptions(payload = {}): RequestInit {
    const additionalOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
    };

    return { ...defaultGetOptions(), ...additionalOptions };
}

export function defaultPostOptions(payload = {}): RequestInit {
    const additionalOptions: RequestInit = {
        method: 'POST',
        body: JSON.stringify(payload),
        credentials: 'include',
    };

    return { ...defaultGetOptions(), ...additionalOptions };
}

export function getErrorMessage(error: unknown): string {
    let errorMessage = 'Unknown error';

    if (error instanceof Error) {
        errorMessage = error.message;
    } else {
        errorMessage = String(error);
    }

    return errorMessage;
}

export function logErrorToConsole(error: unknown): void {
    console.error(getErrorMessage(error));
}

export default {
    defaultFetchOptions: defaultGetOptions,
    defaultHeadOptions,
    defaultDeleteOptions,
    defaultPatchOptions,
    defaultPutOptions,
    defaultPostOptions,
    logErrorToConsole,
    getErrorMessage,
};
